import { useLocation } from 'react-router-dom';
import { StorefrontRouteStates } from '@/features/website-templates/components/storefront-route-states';
import { TemplateLibraryScreen } from '@/features/website-templates/components/template-library-screen';
import { useStorefrontEditorData } from '@/features/website-templates/hooks/use-storefront-editor-data';
import { templateLibraryNotice } from '@/features/website-templates/lib/template-routes';

/**
 * `/storefront/templates`: the library, reached with "Change template", or
 * sent here by the edit route when its template cannot be opened.
 */
export function StorefrontTemplatesRoute(): React.JSX.Element {
  const location = useLocation();
  const data = useStorefrontEditorData(null);
  if (data.status !== 'ready') return <StorefrontRouteStates data={data} />;
  return (
    <TemplateLibraryScreen
      storeId={data.storeId}
      storeSlug={data.storeSlug}
      state={data.state}
      reason="change"
      notice={templateLibraryNotice(location.state)}
    />
  );
}
